export const pluralize = (word: string, count: number, pluralOverride?: string): string => {
  if (count === 1) return word;
  if (pluralOverride) return pluralOverride;

  // Words ending in s, x, z, ch, sh → add "es"
  if (/(?:s|x|z|ch|sh)$/i.test(word)) return `${word}es`;

  return `${word}s`;
};

export function capitalizeEveryFirstLetter(str: string) {
  return str.replace(/\b\w/g, (char) => char.toUpperCase());
}

// Format number with commas for display
export const formatNumberInput = (
  value: string,
  allowDecimals: boolean,
  maxDecimals: number,
): string => {
  // Remove all non-numeric characters except decimal point
  let cleaned = value.replace(/[^\d.]/g, '');

  if (!allowDecimals) {
    // Remove decimal point if decimals not allowed
    cleaned = cleaned.replace(/\./g, '');
  } else {
    // Ensure only one decimal point
    const parts = cleaned.split('.');
    if (parts.length > 2) {
      cleaned = parts[0] + '.' + parts.slice(1).join('');
    }

    // Limit decimal places
    if (parts.length === 2 && parts[1].length > maxDecimals) {
      cleaned = parts[0] + '.' + parts[1].substring(0, maxDecimals);
    }
  }

  return cleaned;
};
